import React, { useEffect } from "react";
import { func, bool, object, string } from "prop-types";
import { push } from "react-router-redux";
import "!style-loader!css-loader!./styles.css";
import { trackUpgradeTooltipTriggered } from "utils/trackingFunctions";
import { scheduleDemoManageMenu } from "../../containers/GlobalNavBar/helpers";
import { UPGRADE_TOOLTIP_CONTENT } from "./constants";

const UpgradeTooltipContent = ({
  onMouseLeave,
  isFreeTrial,
  userData,
  feature,
  utmContent,
  utmCampaign,
  source,
  dispatch,
}) => {
  useEffect(() => {
    trackUpgradeTooltipTriggered(feature, source);
  }, []);

  const handleCTAClick = (e) => {
    e.preventDefault();
    if (isFreeTrial) {
      const utmParameters = {
        content: utmContent,
        campaign: utmCampaign,
        source: "platform",
        medium: userData?.companyAccountId,
      };

      const url = scheduleDemoManageMenu(
        isFreeTrial,
        userData.rep,
        userData.numberOfEmployees,
        utmParameters
      );

      window.open(url, "_blank", "noopener");
    } else {
      onMouseLeave();
      dispatch(push("/packagingPage"));
    }
  };

  const showScheduleDemoContent =
    isFreeTrial && feature === "structuredInterviewing";

  return (
    <>
      <div
        className="d-flex align-items-center font-weight-bold"
        style={{ gap: "4px" }}
      >
        {feature && UPGRADE_TOOLTIP_CONTENT[feature].title}
        {!showScheduleDemoContent && (
          <span className="upgrade-tag">Upgrade</span>
        )}
      </div>
      <p className="mb-0">
        {feature && UPGRADE_TOOLTIP_CONTENT[feature].description}
      </p>
      <button
        type="button"
        className="btn btn-outline-primary btn-md px-3"
        onClick={(e) => handleCTAClick(e)}
      >
        {showScheduleDemoContent ? "Schedule a Demo" : "Compare Plans"}
      </button>
    </>
  );
};

UpgradeTooltipContent.propTypes = {
  onMouseLeave: func.isRequired,
  isFreeTrial: bool.isRequired,
  userData: object.isRequired,
  feature: string.isRequired,
  utmContent: string,
  utmCampaign: string,
  source: string.isRequired,
  dispatch: func.isRequired,
};

export default UpgradeTooltipContent;
